import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { TSelectedRecommendedPackageId } from '../../types/reducers/recommendedPackages';

export const SET_SELECTED_RECOMMENDED_PACKAGE_ID = 'SET :: RECOMMENDED_PACKAGE :: ID';

export type TSetSelectedRecommendedPackageIdAction = IReduxAction<
  typeof SET_SELECTED_RECOMMENDED_PACKAGE_ID,
  TSelectedRecommendedPackageId
>;

export const setSelectedRecommendedPackageId = actionGenerator<
  typeof SET_SELECTED_RECOMMENDED_PACKAGE_ID,
  TSelectedRecommendedPackageId
>(SET_SELECTED_RECOMMENDED_PACKAGE_ID);
